// common footer email and phone number
export const phoneNumber= "(023) 388-2268";

export const emailAddress= "admin@contendzone.com";